import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'tracking-page-delivery-promise',
  templateUrl: './tracking-page-delivery-promise.component.html',
  styleUrls: ['./tracking-page-delivery-promise.component.scss', '../../../tracking-page.component.scss'],
  standalone: false,
})
export class TrackingPageDeliveryPromiseComponent {
  @Input() formGroup: FormGroup;

  get isShippingMethodPromiseEnabled(): boolean {
    return this.formGroup?.get('widgets.deliveryPromise.showShippingMethodPromise')?.value ?? false;
  }

  get isCarrierETAEnabled(): boolean {
    return this.formGroup?.get('widgets.deliveryPromise.showCarrierETA')?.value ?? false;
  }

  get behaviorBannerText(): string | null {
    const shippingPromise = this.isShippingMethodPromiseEnabled;
    const carrierETA = this.isCarrierETAEnabled;

    if (shippingPromise && carrierETA) {
      return 'Current behavior: Shipping method promise will be displayed. Carrier ETA will be used as a fallback when shipping method promise is unavailable.';
    }

    if (shippingPromise && !carrierETA) {
      return 'Current behavior: Only shipping method promise will be displayed. No fallback if unavailable.';
    }

    if (!shippingPromise && carrierETA) {
      return 'Current behavior: Only carrier ETA will be displayed.';
    }

    return null;
  }
}
